import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import {
  NotificationService,
  ModalService,
  BackendService,
  TableSettings,
  TableActionEnum,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { VideoUputstvaService } from '../../services/video-uputstva.service';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-video-uputstva',
  templateUrl: './video-uputstva.component.html',
})
export class VideoUputstvaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  public showDetails = false;
  public tableSettings: TableSettings;
  private _url: string = environment.uputstvaUrl;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _videoUputstvaService: VideoUputstvaService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this.setTableSettings();
    });
  }

  setTableSettings() {
    const settings = this._videoUputstvaService.getSettings();
    this.tableSettings = new TableSettings(settings, 'table');
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  loadSettings() {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSVUP_VUP,
      FormName.VideoUputstva,
      EndpointTypes.GetAllEntities,
      null,
      null,
      null,
      true
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();
          this.orderList = response.ServiceData;
          this.setRbr(this.orderList);
          this.setId(this.orderList);
        })
    );
  }

  onSelectRow(event: any) {
    if (event.action === TableActionEnum.Click) {
      const naziv = event.document.Naziv;
      this.downloadFile(`${this._url}/Video?filename=${naziv}`, naziv);
    }
  }

  downloadFile(dataurl, filename) {
    const a = document.createElement('a');
    a.href = dataurl;
    a.setAttribute('download', filename);
    a.click();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/video-uputstva/video-uputstva.component.ts